import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { IFormTypes } from '../../data/form-types';
import { FormControl, FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { LookupDataService } from '../../services/lookup-data.service';
import { Observable } from 'rxjs';
import { LookupItem } from '../../models/lookup-item';
import { RelationshipPartner } from '../../models/relationship-partner';
import { Validators } from '@angular/forms';
import { AssessmentService } from '../../services/assessment.service';
import { OptionItem } from '../../data/option-item';
import { IFormComponent } from '../../models/i-form-component';

@Component({
  selector: 'app-relationship-partner',
  templateUrl: './relationship-partner.component.html',
  styleUrl: './relationship-partner.component.scss'
})
export class RelationshipPartnerComponent implements OnInit, IFormComponent {

@Input()model!: InitialAssessmentForm;
  @Input()formTypes!: IFormTypes;
  @Input()relationStatuses!: OptionItem[];
  @Output() formReady = new EventEmitter<FormGroup>();


  formBuilder = inject(NonNullableFormBuilder);
    relationshipPartnerForm = this.formBuilder.group({
      status: ['', Validators.required],
      metInPerson: [''],
      firstMet: [''],
      relationshipStart: [''],
      dateMarried: [''],
      intendToMarry: [''],
      datePlannedMarriage: [''],
      liveTogether: [''],
      startedLivingTogether: [''],
      haveChildren: [''],
      numChildren: ['']

    });

    showMetInPerson: boolean = false;
    showFirstMet: boolean = false;
    showRelationshipStart: boolean = false;
    showDateMarried: boolean = false;
    showIntendToMarry: boolean = false
    showDatePlannedMarriage: boolean = false;
    showLiveTogether: boolean = false;
    showStartedLivingTogether: boolean = false;
    showHaveChildren: boolean = false;
    showNumChildren: boolean = false;



  constructor(private assessmentService: AssessmentService) { }
  
  isFormValid(): boolean {
    return this.relationshipPartnerForm.valid;
  }
  markFormAsTouched(): void {
    this.relationshipPartnerForm.markAllAsTouched();
  }



  ngOnInit(): void {


    this.initializeForm();
    this.applyValidatorsAndShowFlags();

  
    this.formReady.emit(this.relationshipPartnerForm);
  }


    initializeForm(){
          
    this.model = this.model || new InitialAssessmentForm();
    this.model.relationshipPartner = this.model.relationshipPartner || new RelationshipPartner();
        
      this.relationshipPartnerForm?.patchValue(this.model.relationshipPartner);   

      this.setInitialFlagsBasedOnModel();

      this.relationshipPartnerForm?.valueChanges.subscribe(value => {
        if (this.model.relationshipPartner && value) {
            Object.assign(this.model.relationshipPartner, {
            ...this.model.relationshipPartner!,
            ...value
            });
          
        }

      });

  
    }



    private setInitialFlagsBasedOnModel(): void {
   if(this.relationshipPartnerForm.controls.status){

        var status = this.relationshipPartnerForm.controls.status.value;

        this.applyStatusUIFlags(status);

        if(this.relationshipPartnerForm.controls.metInPerson.value){
           this.applyMetInPersonUIFlags(this.relationshipPartnerForm.controls.metInPerson.value, status);
        }

        if(this.relationshipPartnerForm.controls.haveChildren.value){
          this.applyHaveChildrenFlags(this.relationshipPartnerForm.controls.haveChildren.value);
        }

        if(this.relationshipPartnerForm.controls.intendToMarry.value){
          this.applyIntendToMarryUIFlags(this.relationshipPartnerForm.controls.intendToMarry.value);
        }
        if(this.relationshipPartnerForm.controls.liveTogether.value){
          this.applyLiveTogetherUIFlags(this.relationshipPartnerForm.controls.liveTogether.value);
        }

      }
    
    }

    private applyMetInPersonUIFlags(metInPersonValue: string, status: string): void {
      
        if(status === 'married' ){
          this.showLiveTogether = true;
          this.showHaveChildren = true;
          this.showFirstMet = false;
        }

        if(status === 'de-facto'){
          this.showLiveTogether = true;
          this.showHaveChildren = true;
          this.showFirstMet = true;
        }

       if ((status === 'engaged' || status === 'interdependent') && metInPersonValue === 'true') {
          this.showFirstMet = true;
          this.showLiveTogether = true;
          this.showHaveChildren = true;
        } else if (metInPersonValue === 'false') {
          this.showFirstMet = false;
          this.showLiveTogether = false;
          this.showStartedLivingTogether = false;
          this.showHaveChildren = false;
        }
        
    }

    private applyHaveChildrenFlags(haveChildrenValue: string): void {
      const numChildrenControl = this.relationshipPartnerForm.controls.numChildren;
      if (haveChildrenValue === 'true') {
          numChildrenControl.setValidators([Validators.min(0)]);
          this.showNumChildren = true;
        } else {
          numChildrenControl.setValidators([]);
          this.showNumChildren = false;
        }
    }

    private applyIntendToMarryUIFlags(intendToMarryValue: string): void {
      if (intendToMarryValue === 'true') {
        this.showDatePlannedMarriage = true;
      } else {
        this.showDatePlannedMarriage = false;
      }
    }

    private applyStatusUIFlags(status: string): void {

      const metInPersonControl = this.relationshipPartnerForm.controls.metInPerson;

    
          
          this.showMetInPerson = false;
          this.showDateMarried = false;
          this.showHaveChildren = false;
          this.showFirstMet = false;
          this.showIntendToMarry = false;
          this.showLiveTogether = false;
          this.showStartedLivingTogether = false;
          this.showDatePlannedMarriage = false;

          if(status === 'engaged' ){
            this.showMetInPerson = true;
            this.showDatePlannedMarriage = true;
          }

          if (status === 'interdependent') {
            this.showMetInPerson = true;
          }

          if (status === 'married') {
            this.showDateMarried = true;
            this.showHaveChildren = true;
            metInPersonControl.setValue('true');
          }

          if (status === 'de-facto') {
            this.showIntendToMarry = true;
             metInPersonControl.setValue('true');

          }

    }

    private applyLiveTogetherUIFlags(liveTogetherValue: string): void {
      if (liveTogetherValue === 'true') {
        this.showStartedLivingTogether = true;
      } else {
        this.showStartedLivingTogether = false;
      }
    }

    private applyValidatorsAndShowFlags(): void {

      const statusControl = this.relationshipPartnerForm.controls.status;
      const metInPersonControl = this.relationshipPartnerForm.controls.metInPerson;
      const intendToMarryControl = this.relationshipPartnerForm.controls.intendToMarry;
      const liveTogetherControl = this.relationshipPartnerForm.controls.liveTogether;
      const haveChildrenControl = this.relationshipPartnerForm.controls.haveChildren;


      statusControl.valueChanges.subscribe(status => {

        // Reset dependent controls and flags and model when status changes
        this.model.relationshipPartner = new RelationshipPartner();
        this.model.relationshipPartner.status = status;
        if(this.relationshipPartnerForm.controls.relationshipStart.value){
          this.model.relationshipPartner.relationshipStart = this.relationshipPartnerForm.controls.relationshipStart.value;
        }
        this.resetStatusDependentControls();
        this.applyStatusUIFlags(status);
        this.relationshipPartnerForm.updateValueAndValidity();
                     
      });

      metInPersonControl.valueChanges.subscribe(metInPerson => {
        
      var status = statusControl.value;

       this.applyMetInPersonUIFlags(metInPerson, status);
        
        this.relationshipPartnerForm.updateValueAndValidity();
      });

      haveChildrenControl.valueChanges.subscribe(haveChildren => {

        this.applyHaveChildrenFlags(haveChildren);
        
        this.relationshipPartnerForm.updateValueAndValidity();
      });

    intendToMarryControl.valueChanges.subscribe(intendToMarry => {
                
      this.applyIntendToMarryUIFlags(intendToMarry);
      
      this.relationshipPartnerForm.updateValueAndValidity();
    });

    liveTogetherControl.valueChanges.subscribe(liveTogether => {

    this.applyLiveTogetherUIFlags(liveTogether);

      this.relationshipPartnerForm.updateValueAndValidity();
    });
  }


private resetStatusDependentControls(): void {
  this.resetControl(this.relationshipPartnerForm.controls.metInPerson);
  this.resetControl(this.relationshipPartnerForm.controls.firstMet);
  this.resetControl(this.relationshipPartnerForm.controls.dateMarried);
  this.resetControl(this.relationshipPartnerForm.controls.intendToMarry);
  this.resetControl(this.relationshipPartnerForm.controls.datePlannedMarriage);
  this.resetControl(this.relationshipPartnerForm.controls.liveTogether);
  this.resetControl(this.relationshipPartnerForm.controls.startedLivingTogether);
  this.resetControl(this.relationshipPartnerForm.controls.haveChildren);
  this.resetControl(this.relationshipPartnerForm.controls.numChildren);
}

  private resetControl(formControl: FormControl) {
    formControl.reset();
    formControl.setValidators([]);
    formControl.updateValueAndValidity();
  }
}
